export default "__VITE_ASSET__Db0E_bpF__"